// Initial Custom Map Constants
export const VALID_MAP_STYLE_TYPES = [ 'satellite', 'barikoi_dark', 'barikoi_one_map', 'barikoi_osm_liberty' ]